import React from 'react';

const time = (
  <svg width="48" height="48" viewBox="0 0 48 48">
    <path d="M23.99 4C12.94 4 4 12.95 4 24s8.94 20 19.99 20C35.04 44 44 35.05 44 24S35.04 4 23.99 4zM24 40c-8.84 0-16-7.16-16-16S15.16 8 24 8s16 7.16 16 16-7.16 16-16 16zM25 14h-3v12l10.49 6.3L34 29.84l-9-5.34z" />
  </svg>
);
const chevronLeft = (
  <svg width="1792" height="1792" viewBox="0 0 1792 1792">
    <path d="M1427 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z" />
  </svg>
);

export default {
  time,
  chevronLeft
};
